export default {
  uploadInstructions:
    "Upload a CSV file, that contains the list of users you wish to add. The list of users in the CSV file will be displayed in the table below. You will be able to make any needed adjustments or fix any errors in the table as well.",
  csvSampleText:
    "A CSV Template File is available for download that includes the required data fields. It can be used as a starting template for a multi-user CSV file.",
};
